import { render, staticRenderFns } from "./listaComentario.vue?vue&type=template&id=2a153aae"
import script from "./listaComentario.vue?vue&type=script&lang=js"
export * from "./listaComentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports